class Cache {
    static localCache = {};

    get(key) {
        return Cache.localCache[key];
    }

    set(key, data, timeoutMins) {
        if (Array.isArray(data)) {
            Cache.localCache[key] = data;
        }

        setTimeout(() => {
            Cache.localCache[key] = [];
        }, timeoutMins * 60000);

        return Cache.localCache;
    }

    clear(key) {
        Cache.localCache[key] = [];

        return Cache.localCache[key];
    }
}

export const cache = new Cache();
